import { components } from './components';
import { documentLogin } from './documentLogin';
import { login } from './login';
import { passwordChannels } from './passwordChannels';
import { passwordOTP } from './passwordOTP';
import { passwordRecovery } from './passwordRecovery';
import { signup } from './signup';
import { updatePassword } from './updatePassword';

const pt = {
  ...documentLogin,
  ...login,
  ...passwordRecovery,
  ...signup,
  ...updatePassword,
  ...passwordChannels,
  ...components,
  ...passwordOTP,
};

export default pt;
